export const dialInTypes = {
  AUDIO_LISTENING: 'DialInAudioListening',
  CONFERENCE: 'DialInConference',
};
